import '../sass/variables.scss'
import '../sass/fonts.css'
import '../sass/colors.scss'

export default {}
